import React from "react";
import Nav from './nav'
import Main from './main'
import Footer from './footer'


function Home(){
    return(
        <div >
            <Nav />
            <Main />
            <Footer />
        </div>
    )
}

export default Home;